<app-document-subheader></app-document-subheader>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (this.documentBase$ | async; as document) {
        <div
          class="page-container"
          >
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col">
                    <div class="form-group">
                      <label class="form-title-label" translate
                        >COUNTRY_LBL_NAME</label
                        >
                        <div class="form-title"></div>
                      </div>
                    </div>
                  </div>
                  <div class="row"></div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
      @if (this.documentBase$ | async; as document) {
        <div class="col-comment">
          <app-comment-panel
            [entityType]="'Document'"
            [entityId]="document.id.toString()"
          ></app-comment-panel>
        </div>
      }
    </div>
  </div>
